// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const FEATURE_NAME_VALUES = [
  'ACCESS_MANAGER',
  'ACCESS_MANAGER_EXPORT_IMPORT',
  'ACQUIRE_OBJECTTYPE_DATA',
  'ADD_EXTERNAL_LAYERS',
  'ADMINISTRATION',
  'ANALYTICS_AGGREGATION_WITH_STD',
  'CADENZA_DEBUGGING',
  'CADENZA_JS_SANDBOX',
  'CLIENT_SIDE_RENDERED_LEGEND',
  'CLIENT_SIDE_LAYER_RENDERING',
  'CONDITIONAL_DISPLAY_IN_REPORTS_AND_WORKSHEETS',
  'COPY_OBJECTTYPE_WITH_DATA',
  'COUPLE_MAP_VIEWS',
  'CREATE_EDIT_SKETCH_CATALOG',
  'CREATE_EMPTY_MAP_VIEW',
  'CREATE_OBJECTTYPE_BASED_ON_TEMPLATE',
  'CREATE_PROJECT',
  'CREATE_PROJECT_COMPOSITE',
  'PROJECT_COMPOSITE',
  'CREATE_REPOSITORY',
  'CREATE_ROUTING_REPORT',
  'CREATE_SKETCH_LAYER',
  'CREATE_WORKBOOK_REPORT',
  'CSV_EXPORT',
  'CUSTOM_SKETCH_EDITORS',
  'DATA_PROTECTION',
  'DATASOURCE_ARCGIS_REST',
  'DATASOURCE_ARCGIS_RASTER',
  'DATASOURCE_ELASTIC_SEARCH',
  'DATASOURCE_OPEN_SEARCH',
  'DATASOURCE_SAP_HANA',
  'DATASOURCE_WFS',
  'DELETION_DEADLINE',
  'EDIT_ATTRIBUTE_FUNCTION',
  'EDIT_GROUP',
  'EDIT_REPORT',
  'EDIT_ROLE',
  'EDIT_SKETCH_LAYER',
  'EDITABLE_GEOMETRY_TRANSLATION',
  'EXCEL_EXPORT',
  'EXPORT_DATABASE_REPOSITORY',
  'EXPORT_GEOPACKAGE',
  'GEOCODER_IP',
  'GEOCODER_IP_OPERATION',
  'GEOCODING',
  'GEOCODING_STRUCTURED',
  'GEOCODING_UNSTRUCTURED',
  'GUEST_ACCESS',
  'HIDPI_RENDERING',
  'IMPORT_ARCHIVE',
  'IMPORT_DATABASE_REPOSITORY',
  'IMPORT_GEOPACKAGE',
  'IMPORT_GEOJSON',
  'IMPORT_PRESETS',
  'JSON_EXPORT',
  'KML_EXPORT',
  'GPX_EXPORT',
  'LIST_GROUP',
  'LIST_USER',
  'MANAGE_ALL',
  'ANALYTICS_EXTENSIONS',
  'MANAGE_ANALYTICS_EXTENSIONS',
  'MANAGE_DATA_PROTECTION_CONTEXT',
  'MANAGE_DATA_SOURCES',
  'MANAGE_EXTERNAL_LINKS',
  'MANAGE_CURATED_MAP_VIEWS',
  'MANAGE_PROJECTS',
  'MANAGE_REPORT_TEMPLATES',
  'MANAGE_WORKBOOK_SNAPSHOTS',
  'MANAGE_LOCATION_FINDER',
  'LOCATION_FINDER',
  'MANAGE_SYSTEM_SETTINGS',
  'MAP_PRINT',
  'MARK_OBJECTTYPE_AS_TEMPLATE',
  'MODIFY_MAP_ANIMATION_CONFIGURATION',
  'OAUTH',
  'OBJECTTYPE_ENRICHMENT',
  'OBJECTTYPE_USAGES_TAB',
  'PASSWORD_CHANGE',
  'PLAY_MAP_ANIMATION',
  'PROMETHEUS',
  'PURPOSE_OF_REQUEST',
  'REACTIVATE_DATA_PROTECTION_CONTEXT',
  'REVERSE_GEOCODING',
  'ROUNDTRIP_MEASUREMENT',
  'ROUTING',
  'ROUTING_ISOCHRONES',
  'SELF_SERVICE_IMPORT',
  'SET_DEFAULT_MAP',
  'SHAPEFILE_EXPORT',
  'SHOW_I18N_TILDES',
  'SUBSCRIBE_TO_WORKBOOK',
  'TIMELINE',
  'TIMELINE_3D',
  'TIMELINE_IMPORT',
  'UNPUBLISHED_CADENZA_API',
  'WHAT3WORDS',
  'WORKBOOK',
  'WORKBOOK_CREATION',
  'WORKBOOK_EDIT_ADVANCED_LAYER_SETTINGS',
  'WORKBOOK_EDIT_SPATIAL_CONDITION',
  'WORKBOOK_ZIP_EXPORT_IMPORT',
  'WORKBOOK_PERFORMANCE_ANALYSIS',
  'WORKBOOK_PERSONAL_SNAPSHOTS',
  'WORKBOOK_TEMPORARY_SNAPSHOTS',
  'WORKBOOK_CHART_REALTIME',
  'WORKBOOK_TRANSFER_OBJECTTYPE_TO_REPOSITORY',
  'WORKBOOK_CALCULATION_ATTRIBUTES',
  'WPS',
  'WRITABLE_DATABASE_REPOSITORY',
  'WRITABLE_DATABASE_REPOSITORY_WITH_CMDB',
  'WRITABLE_DATABASE_REPOSITORY_WITH_WRITABLE_FOLDER',
  'WRITABLE_DATABASE_REPOSITORY_WITH_CMDB_AND_WRITABLE_FOLDER',
  'MAIL_SENDING',
  'ADD_LAYER_FROM_NAVIGATOR',
  'CADENZA_AI',
] as const;

/** @see net/disy/cadenza/api/feature/FeatureName.java */
export type FeatureName = (typeof FEATURE_NAME_VALUES)[number];

export const FeatureName = {
  values: FEATURE_NAME_VALUES as readonly FeatureName[],
} as const;

// </GENERATED-CODE>

export const isFeatureName = (value: string): value is FeatureName => FEATURE_NAME_VALUES.includes(value as never);
